//atom
import React from 'react';
import {Modal} from '@mui/material';
import {ModalWindowProps} from './ModalWindow.type';

import style from './ModalWindow.style.module.scss';

/**
 * Atomic Modal Window component
 * Displays child components on a modal window overlaying all other elements
 * controlled with props
 */
export function ModalWindow(props: ModalWindowProps) {
  const onClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (props.onClose) props.onClose(e);
  };
  const onClickModal = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  return (
    <Modal
      open={props.isOpen}
      className={props.className}
      onClose={onClose}
      onClick={onClickModal}>
      <div className={style.content}>{props.children}</div>
    </Modal>
  );
}
